<template>
  <v-app class="app">
    <transition name="fade">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'App',
  beforeDestroy() {
    if (typeof window === 'undefined') return;
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    ...mapActions('common', ['setIsMobile']),
    onResize() {
      this.setIsMobile(window.innerWidth < 767);
    },
  },
};
</script>

<style lang="scss">
.app {
}
</style>
